import React from 'react';
import styled from 'styled-components';
import colors from '../../styles/colors';
import Button from '../Button';

const Container = styled.div`
  width: 35vw;
  margin: 0 10px;
  list-style: none;
  /* padding: 0 15px; */
  overflow: auto;
  position: relative;
  padding: 0 10px;

  @media screen and (max-width: 991px) {
    width: 50vw;
  }

  @media screen and (max-width: 450px) {
    width: calc(75vw - 20px);
    max-height: 70vh;
  }
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
`;

const ButtonContainer = styled.div`
  margin: 20px 0px;
  width: 100%;
  display: flex;
  flex-direction: row;
  height: ${(props) => (props.height ? props.height : 'auto')};
  align-items: center;
  ${(props) => (props.noBorder ? null : ` border: 1px solid ${colors.grey5}`)};
  border-radius: 7px;
  min-height: 40px;
  justify-content: space-around;
  @media screen and (max-width: 767px) {
    margin: 10px 0px;
  }
`;

const OPTIMAL_CAMPAIGN_REMINDER = 'To reduce the number of opt-outs and spam alerts, campaigns for dinner service should be sent or scheduled to send between 2:45pm-3:25pm, and campaigns for lunch should be sent or scheduled to send between 10am-10:30am';

const OptimalCampaignTimings = ({
  close,
  sendCampaign,
  loading,
  scheduleCampaign,
  isSendingNow,
}) => {
  return (
    <Container>
      <p style={{ fontSize: '13px', paddingTop: '25px' }}>
        {OPTIMAL_CAMPAIGN_REMINDER}
      </p>
      <ButtonContainer noBorder>
        <Button
          background="grey"
          text="Edit Campaign"
          onClick={() => close()}
          type="button"
          xswidth="100px"
          margin="0"
        />
        <Button
          background={colors.seaGreen}
          disabled={loading}
          text={isSendingNow ? 'Send Now' : 'Schedule'}
          onClick={() => (isSendingNow ? sendCampaign() : scheduleCampaign())}
          loading={loading}
          type="button"
          xswidth="100px"
          margin="0 10px"
        />
      </ButtonContainer>
    </Container>
  );
};

export default OptimalCampaignTimings;
